import React, { useState } from "react";
import {
  Modal,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Checkbox,
  TextField,
  Button,
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";

const LoadFromSalesOrderModal = ({
  open = false,
  fCloseSearchModal = () => {},
  xTitle = "",
}) => {
  const [expanded, setExpanded] = useState(null);

  const [maindata, setMaindata] = useState([
    {
      VocNo: "INV001",
      PostDt: "2024-01-01",
      VendorName: "ABC Suppliers",
      Location: "Warehouse A",
      SalesPerson: "John Doe",
      Narration: "Urgent Order",
      subData: [
        { SrNo: 1, ItemCode: "ITM001", ItemName: "Item A", Qty: 10, Unit: "PCS", EditQty: 10, selected: false },
        { SrNo: 2, ItemCode: "ITM002", ItemName: "Item B", Qty: 5, Unit: "BOX", EditQty: 5, selected: false },
      ],
    },
    {
      VocNo: "INV002",
      PostDt: "2024-01-05",
      VendorName: "XYZ Traders",
      Location: "Warehouse B",
      SalesPerson: "Jane Smith",
      Narration: "Regular Supply",
      subData: [
        { SrNo: 1, ItemCode: "ITM003", ItemName: "Item C", Qty: 8, Unit: "PCS", EditQty: 8, selected: false },
        { SrNo: 2, ItemCode: "ITM004", ItemName: "Item D", Qty: 15, Unit: "BOX", EditQty: 15, selected: false },
      ],
    },
  ]);

  const handleAccordionChange = (panel) => {
    setExpanded((prev) => (prev === panel ? null : panel));
  };

  const handleCheckboxChange = (vocIndex, subIndex) => {
    setMaindata((prevData) =>
      prevData.map((item, i) =>
        i === vocIndex
          ? {
              ...item,
              subData: item.subData.map((sub, j) =>
                j === subIndex
                  ? { ...sub, selected: !sub.selected, EditQty: sub.selected ? 0 : sub.Qty }
                  : sub
              ),
            }
          : item
      )
    );
  };

  const handleSelectAll = (vocIndex, isChecked) => {
    setMaindata((prevData) =>
      prevData.map((item, i) =>
        i === vocIndex
          ? {
              ...item,
              subData: item.subData.map((sub) => ({
                ...sub,
                selected: isChecked,
                EditQty: isChecked ? sub.Qty : 0,
              })),
            }
          : item
      )
    );
  };

  const handleQtyChange = (vocIndex, subIndex, value) => {
    setMaindata((prevData) =>
      prevData.map((item, i) =>
        i === vocIndex
          ? {
              ...item,
              subData: item.subData.map((sub, j) =>
                j === subIndex ? { ...sub, EditQty: value } : sub
              ),
            }
          : item
      )
    );
  };

  const handleLoad = (vocIndex) => {
    const selectedVOC = maindata[vocIndex];
    const selectedSubData = selectedVOC.subData.filter((sub) => sub.selected);

    if (selectedSubData.length === 0) {
      alert("No items selected for this VOC.");
      return;
    }

    const loadedData = {
      VocNo: selectedVOC.VocNo,
      PostDt: selectedVOC.PostDt,
      VendorName: selectedVOC.VendorName,
      Location: selectedVOC.Location,
      SalesPerson: selectedVOC.SalesPerson,
      Narration: selectedVOC.Narration,
      subData: selectedSubData,
    };

    console.log("Loaded Data:", loadedData);
    fCloseSearchModal();
  };

  return (
    <Modal open={open} onClose={fCloseSearchModal}>
      <Box sx={{ width: "90%", maxWidth: 800, margin: "auto", marginTop: "5%", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Paper sx={{ width: "100%", borderRadius: 2, boxShadow: 6, maxHeight: "80vh", overflowY: "auto", position: "relative" }}>
          {/* Title with Background */}
          <Box sx={{ backgroundColor: "primary.main", color: "white", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
            <Typography variant="h6">{xTitle || "Load from Sales Order"}</Typography>
            <IconButton sx={{ color: "white" }} onClick={fCloseSearchModal}>
              <CloseIcon />
            </IconButton>
          </Box>

          <Box sx={{ padding: 3 }}>
            {maindata.map((main, vocIndex) => (
              <Accordion key={main.VocNo} expanded={expanded === vocIndex} onChange={() => handleAccordionChange(vocIndex)} sx={{ backgroundColor: "#f9f9f9", mb: 1 }}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography variant="subtitle1">
                    {main.VocNo} - {main.PostDt} | {main.VendorName}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {/* Header Row in Primary Color */}
                  <Box sx={{ backgroundColor: "primary.main", color: "white", padding: "10px", borderRadius: 1, display: "flex", flexWrap: "wrap", gap: 2 }}>
                    <Typography variant="body2"><strong>Location:</strong> {main.Location}</Typography>
                    <Typography variant="body2"><strong>Sales Person:</strong> {main.SalesPerson}</Typography>
                    <Typography variant="body2"><strong>Narration:</strong> {main.Narration}</Typography>
                  </Box>

                  <TableContainer component={Paper} sx={{ maxHeight: 300, overflowX: "auto", mt: 2 }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>
                            <Checkbox
                              checked={main.subData.every((sub) => sub.selected)}
                              indeterminate={main.subData.some((sub) => sub.selected) && !main.subData.every((sub) => sub.selected)}
                              onChange={(e) => handleSelectAll(vocIndex, e.target.checked)}
                            />
                          </TableCell>
                          <TableCell>SrNo</TableCell>
                          <TableCell>Item Code</TableCell>
                          <TableCell>Item Name</TableCell>
                          <TableCell>Qty</TableCell>
                          <TableCell>Unit</TableCell>
                          <TableCell>Edit Qty</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {main.subData.map((sub, subIndex) => (
                          <TableRow key={sub.SrNo}>
                            <TableCell>
                              <Checkbox checked={sub.selected} onChange={() => handleCheckboxChange(vocIndex, subIndex)} />
                            </TableCell>
                            <TableCell>{sub.SrNo}</TableCell>
                            <TableCell>{sub.ItemCode}</TableCell>
                            <TableCell>{sub.ItemName}</TableCell>
                            <TableCell>{sub.Qty}</TableCell>
                            <TableCell>{sub.Unit}</TableCell>
                            <TableCell>
                              <TextField type="number" variant="outlined" size="small" value={sub.EditQty} onChange={(e) => handleQtyChange(vocIndex, subIndex, e.target.value)} disabled={!sub.selected} sx={{ width: 100 }} />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Paper>
      </Box>
    </Modal>
  );
};

export default LoadFromSalesOrderModal;
